<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import MessageAudio from 'next/message/chips/MessageAudio.vue';
import { useMessageContext } from '../provider.js';

const { attachments } = useMessageContext();

const attachment = computed(() => {
  return attachments.value[0];
});
</script>

<template>
  <BaseBubble
    class="bg-transparent"
    data-bubble-name="audio"
    meta-padding-class="px-3 pb-2"
  >
    <MessageAudio
      :attachment="attachment"
      class="p-2 text-n-slate-12 skip-context-menu"
    />
  </BaseBubble>
</template>
